export const getCurveLength = (curve) => {
  const point1 = curve.getPointAt(0);
  const point2 = curve.getPointAt(1);

  // Calculate the Euclidean distance between the two points
  return point1.distanceTo(point2);
};
